import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const WeeklySalesPattern = () => {
  const data = [
    ['Week', 'Sales (%)'],
    ['Week 1', 10],
    ['Week 2', 20],
    ['Week 3', 35],
    ['Week 4', 35],
  ];

  const options = {
    title: 'Weekly Sales Pattern Billing',
    pieHole: 0.4,
    slices: [
      { color: '#4CAF50' },
      { color: '#FF9800' },
      { color: '#F44336' },
      { color: '#2196F3' },
    ],
    legend: { position: 'right' },
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="PieChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default WeeklySalesPattern;